// extracted by mini-css-extract-plugin
module.exports = {"render":"LOAnalysis_render__2J4KY","currentPageButton":"LOAnalysis_currentPageButton__Jvtk4","nextPageButton":"LOAnalysis_nextPageButton__1i_i6"};